var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 92,
    rx: 49,
    ry: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.97,
    y: 77.54,
    className: "st1",
    width: 83.61,
    height: 15.46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.06,31.66H18.02c-1.78,0-2.98,1.34-3.23,3.03L8.65,89.22c0,1.57,1.19,2.84,2.67,2.84h43.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.72,53.52L67.6,34.69c-0.25-1.69-1.45-3.03-3.23-3.03H44.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.99,41.62c0,1.51-1.22,2.73-2.73,2.73c-1.51,0-2.73-1.22-2.73-2.73c0-1.51,1.22-2.73,2.73-2.73 C25.77,38.9,26.99,40.12,26.99,41.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.39,61.25c0,1.51-1.22,2.73-2.73,2.73c-1.51,0-2.73-1.22-2.73-2.73c0-1.51,1.22-2.73,2.73-2.73 C65.17,58.52,66.39,59.74,66.39,61.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.43,61.25c0,1.51-1.22,2.73-2.73,2.73c-1.51,0-2.73-1.22-2.73-2.73c0-1.51,1.22-2.73,2.73-2.73 C84.21,58.52,85.43,59.74,85.43,61.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.5,41.62c0,1.51-1.22,2.73-2.73,2.73c-1.51,0-2.73-1.22-2.73-2.73c0-1.51,1.22-2.73,2.73-2.73 C59.28,38.9,60.5,40.12,60.5,41.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.64,38.9V22.72c0-9.22-7.47-16.69-16.69-16.69c-9.22,0-16.69,7.47-16.69,16.69V38.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.12,75.89l1.46,14.33c0,1.02-0.83,1.85-1.85,1.85H54.64c-1.02,0-1.85-0.83-1.85-1.85l3.61-34.3 c0-1.02,0.83-1.85,1.85-1.85h29.78c1.02,0,1.85,0.83,1.85,1.85l1.57,14.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.67,63.98v7.74c0,5.26,4.26,9.52,9.52,9.52c5.26,0,9.52-4.26,9.52-9.52v-7.74"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPickup);
export default __webpack_public_path__ + "static/media/Order&Pickup.de080a8ff6dc3202fe62a9e55636d262.svg";
export { ForwardRef as ReactComponent };